import {getProvisioningSummary} from '@account/api/admin-reports';
import {useQuery} from '@tanstack/react-query';

export const useProvisioningReport = (
  {start, end, granularity, isTrial},
  options = {}
) =>
  useQuery(
    [
      'admin-reports',
      'provisioning-summary',
      start,
      end,
      granularity,
      isTrial ?? '',
    ],
    () => getProvisioningSummary({start, end, granularity, isTrial}),
    {keepPreviousData: true, ...options}
  );
